/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable no-restricted-syntax */
import {
  AmenitiesFilter as AmenityFilterType,
  RatingFilter,
  SrpFilters as SrpFiltersType,
  StarClassificationFilter,
} from '@customTypes/srp-filters';

type NameKeyType = StarClassificationFilter | AmenityFilterType | RatingFilter | string | number;

const convertFilterNames = (filterNames: string[]) => {
  const newFilterNames: string[] = filterNames.map((item: string) => {
    switch (item) {
      case 'five_stars':
        return 'star_classification.5';
      case 'four_stars':
        return 'star_classification.4';
      case 'three_stars':
        return 'star_classification.3';
      case 'less_than_three_stars':
        return 'star_classification.2';
      case 'excellent':
        return 'guest_rating.4.5';
      case 'very_good':
        return 'guest_rating.4';
      case 'good':
        return 'guest_rating.3.5';
      default:
        return item;
    }
  });
  return newFilterNames;
};

const convertFilterUrlParams = (
  params: string | string[] | undefined,
  defaultFilters: SrpFiltersType | undefined,
) => {
  if (!params || !defaultFilters) return;
  const starClassificationFilterItems = Object.keys(defaultFilters.star_classification).map(
    (item) => `star_classification.${item}`,
  );
  const amenitiesFilterItems = Object.keys(defaultFilters.amenities);
  const hotelVibesFilterItems = Object.keys(defaultFilters.hotel_vibes);
  const ratingFilterItems = Object.keys(defaultFilters.guest_rating).map(
    (item) => `guest_rating.${item}`,
  );
  const selectedFiltersArray: string[] = convertFilterNames(params.toString().split(','));
  const filters: SrpFiltersType = defaultFilters;
  filters.star_classification.any = true;
  selectedFiltersArray.forEach((item: string) => {
    if (starClassificationFilterItems.indexOf(item) > -1) {
      filters.star_classification[item.split('star_classification.')[1] as keyof NameKeyType] =
        true as never;
    } else if (amenitiesFilterItems.indexOf(item) > -1) {
      filters.amenities[item as keyof NameKeyType] = true as never;
    } else if (hotelVibesFilterItems.indexOf(item) > -1) {
      filters.hotel_vibes[item as keyof NameKeyType] = true as never;
    } else if (ratingFilterItems.indexOf(item) > -1) {
      if (item !== 'guest_rating.0') {
        filters.guest_rating['4.5' as keyof NameKeyType] = false as never;
        filters.guest_rating['4' as keyof NameKeyType] = false as never;
        filters.guest_rating['3.5' as keyof NameKeyType] = false as never;
        filters.guest_rating[item.split('guest_rating.')[1] as keyof NameKeyType] = true as never;
        filters.star_classification.any = false;
      }
    }
  });
  filters.url = window?.location.href;
  // eslint-disable-next-line consistent-return
  return JSON.stringify(filters);
};

const convertShowOnlyFilterUrlParams = (
  params: string | string[] | undefined,
  defaultFilters: SrpFiltersType | undefined,
) => {
  if (!params || !defaultFilters) return;
  const showOnlyAvailableFilterName = 'only_available';
  const selectedFiltersArray: string[] = params.toString().split(',');
  const filters: SrpFiltersType = defaultFilters;
  filters.url = window?.location.href;
  if (selectedFiltersArray.indexOf(showOnlyAvailableFilterName) > -1) {
    // eslint-disable-next-line consistent-return
    return 'true';
  }
  // eslint-disable-next-line consistent-return
};

export { convertFilterUrlParams, convertShowOnlyFilterUrlParams };
